import { safeObjCopy } from "pxc-editor-core/helpers/common";
import { parseId } from "pxc-editor-core/helpers/schema";
import { PRINTING_MODE } from "./constants";
import { parseMatfilePrintTransforms } from "./helpers/print";
import backgroundPrint from "./components/Printing/backgroundPrint";
export default function backgroundPrintFunc(printObjIds, settings, data, eachItemCallback, finishCallback) {
    if (eachItemCallback === void 0) { eachItemCallback = null; }
    if (finishCallback === void 0) { finishCallback = null; }
    if (!checkPrintObjIds(printObjIds, finishCallback)) {
        return;
    }
    var printSettings = buildPrintSettings(printObjIds, settings, data, eachItemCallback);
    backgroundPrint(printSettings, finishCallback);
}
function checkPrintObjIds(printObjIds, finishCallback) {
    if (finishCallback === void 0) { finishCallback = null; }
    if (!printObjIds.length) {
        if (finishCallback) {
            finishCallback();
        }
        return false;
    }
    else {
        var pageId = parseId(printObjIds[0]).pageId;
        if (!pageId) {
            throw 'Invalid printObjIds';
        }
    }
    return true;
}
function buildPrintSettings(printObjIds, settings, data, eachItemCallback) {
    if (eachItemCallback === void 0) { eachItemCallback = null; }
    var _a = settings.mode, mode = _a === void 0 ? PRINTING_MODE.CONTENT_ONLY : _a, _b = settings.skipMaterialTransforms, skipMaterialTransforms = _b === void 0 ? false : _b, _c = settings.transforms, transforms = _c === void 0 ? [] : _c, _d = settings.resultFormat, resultFormat = _d === void 0 ? 'png' : _d, _e = settings.resolution, resolution = _e === void 0 ? null : _e, _f = settings.individual, individual = _f === void 0 ? null : _f, fillStyle = settings.fillStyle;
    var materialType = data.materialType, materialPrintParameters = data.materialPrintParameters, pages = data.pages, paperColor = data.paperColor, _g = data.isContentPlacingDebugging, isContentPlacingDebugging = _g === void 0 ? false : _g, _h = data.isDebuggingGrid, isDebuggingGrid = _h === void 0 ? false : _h;
    var extendTransforms = transforms;
    if (!skipMaterialTransforms) {
        var printTransforms = parseMatfilePrintTransforms(materialPrintParameters.transforms || []);
        extendTransforms = printTransforms.concat(extendTransforms);
    }
    var pagesCopy = safeObjCopy(pages);
    var transformsCopy = safeObjCopy(extendTransforms);
    return {
        printData: {
            mode: mode,
            pages: pagesCopy,
            paperColor: paperColor,
            isContentPlacingDebugging: isContentPlacingDebugging,
            transforms: transformsCopy,
            individual: individual,
            resolution: resolution,
            skipMaterialTransforms: skipMaterialTransforms,
            materialType: materialType,
            materialPrintParameters: materialPrintParameters,
            isDebuggingGrid: isDebuggingGrid,
            fillStyle: fillStyle
        },
        printObjIds: printObjIds,
        resultFormat: resultFormat,
        eachItemCallback: eachItemCallback
    };
}
